import React, { FC } from 'react';

import { Accept } from 'react-dropzone';

import { Box, Flex, Text } from '@adsk/alloy-react-box';
import { PaperclipIcon } from '@adsk/alloy-react-icon';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import theme from '@adsk/alloy-react-theme';

import { useSupportedFileTypesDescription } from '../../hooks/useSupportedFileTypesDescription';
import { useTranslation } from '../../i18n';
import AttachmentsDropzoneLimitationPopover from '../AttachmentsDropzone/AttachmentsDropzoneLimitationPopover';

export type AttachmentsHeaderProps = {
  numberOfAttachments?: number;
  maxFileSize?: number;
  acceptFileTypes?: Accept;
};

const AttachmentsHeader: FC<AttachmentsHeaderProps> = ({
  numberOfAttachments,
  maxFileSize,
  acceptFileTypes,
}) => {
  const { t } = useTranslation();
  const mimeTypesDescription = useSupportedFileTypesDescription({
    accept: acceptFileTypes,
  });

  return (
    <Flex
      alignItems="center"
      height="56px"
      padding="16px"
      borderBottom={`1px solid ${theme.colors.charcoal200}`}
      data-testid="AttachmentsHeader"
    >
      <PaperclipIcon style={{ marginRight: 8 }} />{' '}
      <Text typography="heading3">
        {t('ATTACHMENTS')}{' '}
        {numberOfAttachments ? `(${numberOfAttachments})` : null}
      </Text>
      <Box
        as="span"
        marginLeft="auto"
        display="inline-flex"
        alignItems="center"
      >
        <AttachmentsDropzoneLimitationPopover
          maxSize={maxFileSize}
          allowedFileTypes={mimeTypesDescription}
        />
      </Box>
    </Flex>
  );
};

export default WithAlloySuspense(AttachmentsHeader);
